import React from 'react'
import { withPrefix } from 'gatsby';
import s from './que-hace-prima-afp-con-mi-dinero.module.css'

const principios = [
  {
    imgSrc: withPrefix('/images/caja-fuerte.svg'),
    imgAlt: 'Paso 1',
    imgHeight: '96px',
    description: 'Estrictos criterios de prudencia en las inversiones que se realizan.'
  },
  {
    imgSrc: withPrefix('/images/asistente-virtual.svg'),
    imgAlt: 'Paso 2',
    imgHeight: '96px',
    description: (
      <>
        Equipo de <br></br>
        expertos en <br></br>
        inversiones.
      </>
    )
  },
  {
    imgSrc: withPrefix('/images/senderista.svg'),
    imgAlt: 'Paso 2',
    imgHeight: '96px',
    description: 'Búsqueda selectiva de oportunidades de inversión.'
  },
  {
    imgSrc: withPrefix('/images/buscando-con-lupa.svg'),
    imgAlt: 'Paso 2',
    imgHeight: '96px',
    description: (
      <>
        Supervisión <br></br>
        estricta de la SBS.
      </>
    )
  },
]

const QueHacePrimaAfpConMiDinero = () => {
  return (
    <div className={'containerWrap'}>
      <div className="container w-100 w-70@lg bg-white tw-p-9 tw-p-12@lg">
        <h2 className="tw-mt-0 tw-mb-3 tw-mb-4@lg center font-family-secondary c-orange-0 fw-7 tw-f-20 tw-f-24@lg">
          ¿Qué hace Prima AFP con mi dinero?
        </h2>

        <div className="tw-mb-4 tw-mb-8@lg center">
          <p className="font-family-primary c-gray--4 fw-4 tw-f-14 tw-f-16@lg">
            Prima AFP administra el dinero de tu fondo con el objetivo de
            maximizar la rentabilidad con el menor riesgo posible. Velamos
            por el bienestar de tu fondo y buscamos el mejor retorno a largo
            plazo para tu dinero, siempre bajo estos principios.
          </p>
        </div>

        <div className="tw-mb-4 tw-mb-8@lg center">
          <p className="font-family-secundary c-gray--4 fw-6 tw-f-16 tw-f-18@lg">
            Siempre bajo estos principios:
          </p>
        </div>

        <div className={`${s.listSteps} ${s.gridDoble} tw-mb-12 tw-mb-16@lg`}>
          {
            principios.map((element) => (
              <div key={element.imgSrc} className={`${s.listItem} ${s.nobgtop} tw-mb-10 tw-mb-0@lg`}>
                <img
                  src={element.imgSrc}
                  alt={element.imgAlt}
                  height={element.imgHeight}
                  className={`${s.listItemImg} tw-mb-6 tw-mb-6@lg`}
                />

                <div className={`${s.listItemDesc} center`}>
                  <div className="font-family-secondary fw-4 tw-f-16 tw-f-16@lg">
                    {element.description}
                  </div>
                </div>
              </div>
            ))
          }
        </div>
      </div>
    </div>
  )
};

export default QueHacePrimaAfpConMiDinero;
